// extracted by mini-css-extract-plugin
export default {"main":"GonogoHeader_main__bor6J","riskName":"GonogoHeader_riskName__n4erl font-xl-bold","square":"GonogoHeader_square__3SMlV","bubble__label":"GonogoHeader_bubble__label__SviRs"};